<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="编码/名称">
              <a-input v-model.trim="queryParam.codeAndName" placeholder />
            </a-form-item>
          </a-col>

          <!-- <a-col :md="8" :sm="24">
            <a-form-item label="业务类型">
              <a-select
                v-model="queryParam.businessTypeId"
                placeholder="请选择">
                <a-select-option v-for="(item, index) in businessTypeSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->

          <a-col :md="!advanced && 4 || 4" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-upload
        accept=".xls,.xlsx"
        :showUploadList="false"
        :action= "config.importLogisticsUrl"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <a-button style="margin-left: 8px" type="primary" icon="plus" >导入</a-button>
      </a-upload>

      <a-button style="margin-left: 8px" type="primary" @click="downLoad()">模板下载</a-button>
      <a-button style="margin-left: 8px" type="primary" @click="handleExport()">导出</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:1000 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
        <span class="blacktr" v-if="blackListOpen && $store.getters.blackList['6'] && $store.getters.blackList['6'][record.id]" ></span>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical"/>
        <a-dropdown>
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item>
            <a v-if="blackListOpen && (!$store.getters.blackList['6'] || !$store.getters.blackList['6'][record.id])" @click="handleBlack(record)">拉黑</a>
            <span v-else>已黑</span></a-menu-item>
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal title="操作" style="top: 200px;" :width="800" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="供用商名称" v-decorator="['name', { initialValue: mdl.name, rules: [{ required: true, message: '请输入供用商名称'}]}]"/>
        </a-form-item>

        <a-form-item label="编码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="供用商编码" v-model="mdl.code"/>
        </a-form-item>

        <a-form-item label="承运业务类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select placeholder="业务类型" v-model="mdl.businessTypeId">
            <a-select-option v-for="(item, index) in businessTypeSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-divider />
      </a-form>
    </a-modal>

    <a-modal title="拉黑" :width="640" v-model="blackModel" @ok="handleBlackOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="企业名" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input disabled placeholder="企业名" v-model="black.name" id="role_name" />
        </a-form-item>

        <a-form-item label="类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select disabled v-model="black.type" placeholder="请选择">
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="拉黑原因" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-textarea
            :rows="1"
            v-model="black.remark"
            placeholder="..."
            id="describe"
            v-decorator="['remark',
            { initialValue: black.remark, rules: [{ required: true, message: '请输入拉黑原因'}]}]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { STable } from '@/components'
  import {
    businessTypeList,
    corpLogisticsDelete,
    corpLogisticsPage,
    corpLogisticsSave,
    corpLogisticsUpdate,
    corpLogisticsSyncData
  } from '@/api/basic'
  import { blackListSave } from '@/api/basic'
  import { formatDate } from '@/utils/date'
  import Bus from '@/layouts/bus'
  import config from '@/config/defaultSettings'

export default {
  name: 'CorpLogistics',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      description:
        '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,
      confirmLoading: false,
      blackModel: false,
      form: this.$form.createForm(this),
      mdl: {},
      black: {},
      blackListOpen: config.blackListOpen,

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      loading: false,
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '40px',
          fixed: 'left'
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: '340px',
        },
        {
          title: '编号',
          dataIndex: 'code',
          width: '200px',
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        }
      ],
      // 所属菜单下拉
      userSelect: null,
      typeSelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return corpLogisticsPage(Object.assign(parameter, this.queryParam)).then(res => {
          setTimeout(() => {
            $('.blacktr').parents('tr').css("background-color", "#ddd")
          }, 1000);
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 业务类型
      businessTypeSelect: null
    }
  },
  created() {
    this.tableOption()
    this.loadSelectData()
  },
  mounted() {
    // setTimeout(() => {
    //   $('.blacktr').parents('tr').css('border-left', '10px solid #000')
    // }, 1000)
  },
  methods: {
    loadSelectData() {
      // 从后台拉取下拉列表数据
      new Promise(resolve => {
        const data = businessTypeList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.businessTypeSelect = res
      })
      this.typeSelect = this.$store.getters.codeList.basic_black_list_type
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },

    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
    },

    handleAdd () {
      this.mdl = {}
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        Object.assign(this.mdl, values)
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            corpLogisticsUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          } else {
            corpLogisticsSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },

    handleBlack(record) {
      this.black['type'] = '6'
      this.black['name'] = record.name
      this.black['recordId'] = record.id
      this.black['remark'] = ''
      this.form = this.$form.createForm(this)
      this.blackModel = true
    },

    handleBlackOk({ commit }) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          blackListSave(Object.assign({}, this.black)).then(res => {
            if (res.code === '0') {
              let blackList = this.$store.getters.blackList
              if (!blackList['6']) blackList['6'] = {}
              blackList['6'][this.black.recordId] = this.black
              this.$store.commit('SET_BLACK', blackList)
              this.$refs.table.refresh()
              this.blackModel = false
              // this.$refs.table.refresh(true)
              // setTimeout(() => {
              //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
              // }, 1000);
            } else {
              this.$message.error(res.message)
            }
          }).catch((e) => {
            console.log(e)
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          nthis.confirmLoading = true
          return corpLogisticsDelete(Object.assign(record, nthis.queryParam))
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            }).catch(e => {
              console.log(e)
            })
        },
        onCancel() {}
      })
    },


    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleChange (info) {
      if (info.file.status === 'uploading') {
        Bus.$emit('showSpinning', true, "准备导入...")
      }

      if (info.file.status === 'done') {
        Bus.$emit('showSpinning', false)
        if (info.file.response && info.file.response.code === '0'){
          this.$message.success('导入成功！')
          this.$refs.table.refresh()
        }else{
          this.$message.error(info.file.response.message)
        }
      }
    },
    beforeUpload (file) {

    },
    downLoad(){
      let url=this.config.downLoadMouldUrl+"运输单位.xlsx"
      window.location.href=url
    },
    handleExport() {
      var codeAndName=this.queryParam.codeAndName
      if(!codeAndName){
        codeAndName=''
      }
      const token = Vue.ls.get(ACCESS_TOKEN)
      window.location.href = this.config.downloadCorpLogisticsUrl + '&accessToken=' + token +'&codeAndName=' +codeAndName
    },
  }
}
</script>
